import { mutatorAction } from 'satcheljs';
import { getStore, ImmersiveReaderFrameState } from 'owa-immersive-reader-store';

const setImmersiveReaderFrameReady = mutatorAction('setImmersiveReaderFrameReady', () => {
    getStore().immersiveReaderFrameState = ImmersiveReaderFrameState.Ready;
});

export default setImmersiveReaderFrameReady;
